import api from "../api";

export const criticidadeService = {
    async loadCriticidade() {
      return await api.get("/criticidades");
    },
    async getPublico() {
      return await api.get("/publico/criticidades");
    }
  }